module.exports = __webpack_public_path__ + "static/hero_faded-50d80888d5257f1a2231465b2c73e24b.png";